<template>
  <div class="gold-view sign-up-view" :class="isCjehApp() ? 'cjeh-app' : ''">
    <div class="header">
      <div class="header-content">
        <div class="header-button header-back" @click="goBack()"></div>
        <h1>报名</h1>
        <div class="header-wenhao" @click="downloadPDF">合投材料下载</div>
      </div>
    </div>
    <!-- <div class="sign-up-tab">
      <div class="row">
        <div
          class="col"
        >
          私募产品组报名
        </div>
        <div
          class="col"
        >
          专业投资者组报名
        </div>
      </div>
    </div> -->
    <!-- 内容 -->
    <div class="view-scroller has-header sign-content" :class="{'has-footer': tabflag === '1'}">
      <!-- <div class="common-box common-input-item" v-show="isSpecial">
        <h3 class="title font-title-color">投资者信息</h3>
        <div class="list">
          <div class="item border-1px-b">
            <span class="span-title">姓名</span>
            <div class="right-box">
              <div class="cell">
                <input
                  type="text"
                  v-model="z_name"
                  class="font-title-color right-span"
                  maxlength="100"
                  placeholder="请填写"
                />
              </div>
            </div>
          </div>
          <div class="item border-1px-b">
            <span class="span-title">*参赛资金账号</span>
            <div class="right-box">
              <div class="cell">
                <input
                  type="text"
                  v-model="z_account"
                  class="font-title-color right-span"
                  maxlength="100"
                  placeholder="请填写"
                />
              </div>
            </div>
          </div>
          <div class="item border-1px-b">
            <span class="span-title">*联系人手机号</span>
            <div class="right-box">
              <div class="cell">
                <input
                  type="text"
                  v-model="z_mobile"
                  class="font-title-color right-span"
                  maxlength="11"
                  placeholder="请填写"
                  @blur="blurEvent('z_mobile')"
                />
              </div>
            </div>
          </div>
          <div class="item border-1px-b">
            <span class="span-title">*图形验证码</span>
            <div class="right-box">
              <div class="cell">
                <input
                  type="text"
                  v-model="z_validateCode"
                  class="font-title-color right-span"
                  style="max-width: 50%; min-width: 50%"
                  maxlength="100"
                  placeholder="请填写"
                />
                <div
                  class="graphic-verification-code"
                  style="max-width: 50%; min-width: 50%"
                  @click="getValidateImg(true)"
                >
                  <img :src="z_imgsrc" />
                </div>
              </div>
            </div>
          </div>
          <div class="item border-1px-b">
            <span class="span-title">*短信验证码</span>
            <div class="right-box">
              <div class="cell">
                <input
                  type="text"
                  v-model="z_smsCode"
                  class="font-title-color right-span"
                  style="max-width: 60%; min-width: 60%"
                  maxlength="100"
                  placeholder="请填写"
                />
                <span
                  class="font-col-orange"
                  ref="z_countdown"
                  style="max-width: 40%; min-width: 40%; text-align: center"
                  @click="sendMsg(z_mobile, z_sessionId, z_validateCode, true)"
                  >获取验证码</span
                >
              </div>
            </div>
          </div>
          <div class="item border-1px-b">
            <span class="span-title">*电子邮箱</span>
            <div class="right-box">
              <div class="cell">
                <input
                  type="text"
                  v-model="z_email"
                  class="font-title-color right-span"
                  maxlength="100"
                  placeholder="请填写"
                  @blur="blurEvent('z_email')"
                />
              </div>
            </div>
          </div>-->
      <!-- 专业推荐部门 -->
      <!--<div class="item border-1px-b z-index-10">
            <span class="span-title">*推荐部门</span>
            <div class="right-box">
              <div class="cell select-cell">
                <input
                  class="select-right-box"
                  type="text"
                  placeholder="请选择推荐部门"
                  v-model="z_recDept"
                  @blur="departBlur()"
                  @focus="departmentFocus = true"
                />
                <i
                  class="ion-arrow"
                  v-show="departSelectList.showDepartOrgOptions"
                ></i>
              </div>-->
      <!--下拉选择box-->
      <!--<div
                class="select-box"
                v-show="departSelectList.showDepartOrgOptions"
                @click.stop
              >
                <cj-scroller direction="y" :noscrollbar="true">
                  <div class="scroller-box">
                    <p
                      class="font-normal-color over-long"
                      v-for="(option, index) in departOptions"
                      :key="index"
                      @click="selectDepartOptions(option.value, index)"
                    >
                      {{ option.text }}
                    </p>
                  </div>
                </cj-scroller>
              </div>
            </div>
          </div>
          <div class="item border-1px-b">
            <span class="span-title">*推荐人</span>
            <div class="right-box">
              <div class="cell">
                <input
                  type="text"
                  v-model="z_recPerson"
                  maxlength="100"
                  class="font-title-color right-span"
                  placeholder="请填写"
                />
              </div>
            </div>
          </div>
          <div class="item border-1px-b">
            <span class="span-title" style="width: auto"
              >申请长江证券CQT交易系统服务</span
            >
            <div class="right-box">
              <label class="toggle">
                <input type="checkbox" v-model="z_cqtChecked" />
                <div class="track">
                  <div class="handle"></div>
                </div>
              </label>
            </div>
          </div>
          <div class="item border-1px-b">
            <span class="span-title" style="width: auto"
              >申请iFind 金融数据终端一年使用权</span
            >
            <div class="right-box">
              <label class="toggle">
                <input type="checkbox" v-model="z_iFundChecked" />
                <div class="track">
                  <div class="handle"></div>
                </div>
              </label>
            </div>
          </div>
        </div>
      </div> -->
      <!-- <div class="common-input-item" v-show="!isSpecial"> -->
      <div class="tab-box">
        <div class="tab-box-item" :class="{'active-item': tabflag == '1'}" @click="tabflag = '1'">私募报名信息</div>
        <div class="tab-box-item" :class="{'active-item': tabflag == '2'}" @click="tabChange">报名产品状态</div>
      </div>
      <!-- 私募机构信息 -->
      <div v-if="tabflag === '1'" class="all-boxs">
          <div class="sign-form">
            <!-- 标题 -->
            <h3 class="sign-from-header">私募机构信息</h3>
            <div class="list">
              <div class="item border-1px-b z-index-10">
                <span class="required">*</span>
                <span class="span-title">机构全称</span>
                <div class="right-box">
                  <div class="cell select-cell">
                    <!-- s_organName -->
                    <input
                      type="text"
                      v-model="s_organName"
                      class="font-title-color right-span"
                      @blur="manageScaleBlur()"
                      maxlength="100"
                      placeholder="以机构全称来搜索"
                      @input="getOrganizationName(s_organName)"
                      @focus="getOrganizationName()"
                    />
                    <i
                      class="ion-arrow"
                      @click="
                        manageScaleList.showDepartOrgOptions =
                          !manageScaleList.showDepartOrgOptions
                      "
                      v-show="manageScaleList.showDepartOrgOptions"
                    ></i>
                  </div>
                  <!--下拉选择box-->
                  <div
                    class="select-box"
                    v-show="manageScaleList.showDepartOrgOptions"
                    @click.stop
                  >
                    <cj-scroller direction="y" :noscrollbar="true">
                      <div class="scroller-box">
                        <p
                          class="font-normal-color over-long"
                          v-for="(option, index) in manageScaleOptions"
                          :key="index"
                          @click="selectScaleOptions(option)"
                        >
                          {{ option.organ_full_name }}
                        </p>
                      </div>
                    </cj-scroller>
                  </div>
                </div>
              </div>
              <div v-show="s_manageScale || s_selectDate || s_assoNum">
                <div class="item border-1px-b">
                  <span class="required">*</span>
                  <span class="span-title">协会登记编号</span>
                  <div class="right-box">
                    <div class="cell">
                      <input
                        type="text"
                        v-model="s_manageScale"
                        class="font-title-color right-span pro-inp"
                        maxlength="100"
                        readonly="readonly"
                        placeholder="选择机构全称后自动填充"
                      />
                    </div>
                  </div>
                </div>
                <div class="item border-1px-b">
                  <span class="required">*</span>
                  <span class="span-title">机构成立日期</span>
                  <div class="right-box">
                    <div class="cell">
                      <input
                        type="text"
                        class="font-title-color right-span"
                        style="max-width: 80%; min-width: 80%"
                        readonly="readonly"
                        v-model="s_selectDate"
                        placeholder="选择协会登记编号后自动填充"
                      />
                      <!-- <span
                      class="calendar-icon"
                      style="max-width: 20%; min-width: 20%"
                      @click="openPicker()"
                    >
                      <i></i>
                    </span> -->
                    </div>
                  </div>
                </div>
                <div class="item border-1px-b">
                  <span class="required">*</span>
                  <span class="span-title">公司管理规模</span>
                  <div class="right-box">
                    <div class="cell">
                      <input
                        type="text"
                        v-model="s_assoNum"
                        class="font-title-color right-span pro-inp"
                        maxlength="100"
                        readonly="readonly"
                        placeholder="选择协会登记编号后自动填充"
                      />
                    </div>
                  </div>
                </div>
              </div>
              <div class="item border-1px-b">
                <span class="required">*</span>
                <span class="span-title">联系人姓名</span>
                <div class="right-box">
                  <div class="cell">
                    <input
                      type="text"
                      v-model="s_name"
                      class="font-title-color right-span"
                      maxlength="100"
                      placeholder="请填写"
                    />
                  </div>
                </div>
              </div>
              <div class="item border-1px-b">
                <span class="required">*</span>
                <span class="span-title">联系人职位</span>
                <div class="right-box">
                  <div class="cell">
                    <input
                      type="text"
                      v-model="s_position"
                      class="font-title-color right-span"
                      maxlength="100"
                      placeholder="请填写"
                    />
                  </div>
                </div>
              </div>
              <!-- <div class="item border-1px-b">
                <span class="required">*</span>
                <span class="span-title">图形验证码</span>
                <div class="right-box">
                  <div class="cell">
                    <input
                      type="text"
                      v-model="s_validateCode"
                      class="font-title-color right-span"
                      style="max-width: 60%; min-width: 60%"
                      maxlength="100"
                      placeholder="请填写"
                    />
                    <div
                      class="graphic-verification-code"
                      style="max-width: 40%; min-width: 40%"
                      @click="getValidateImg(false)"
                    >
                      <img :src="s_imgsrc" alt="重新加载" />
                    </div>
                  </div>
                </div>
              </div>
              <div class="item border-1px-b">
                <span class="required">*</span>
                <span class="span-title">联系人手机号</span>
                <div class="right-box">
                  <div class="cell">
                    <input
                      type="text"
                      v-model="s_mobile"
                      class="font-title-color right-span"
                      maxlength="11"
                      placeholder="请填写"
                      @blur="blurEvent('s_mobile')"
                    />
                  </div>
                </div>
              </div>
              <div class="item border-1px-b">
                <span class="required">*</span>
                <span class="span-title">短信验证码</span>
                <div class="right-box">
                  <div class="cell" style="align-items: center">
                    <input
                      type="text"
                      v-model="s_smsCode"
                      class="font-title-color right-span"
                      style="max-width: 60%; min-width: 60%"
                      maxlength="100"
                      placeholder="请填写"
                    />
                    <div
                      @click="sendMsg(s_mobile, s_sessionId, s_validateCode, false)"
                      style="max-width: 40%; min-width: 40%; border: none"
                    >
                      <div
                        class="font-col-blue"
                        style="width: 100%; padding-left: 0; text-align: center"
                        :style="
                          s_verification == '获取验证码'
                            ? 'opacity: 1;'
                            : 'opacity: 0.5;'
                        "
                      >
                        {{ s_verification }}
                      </div>
                    </div>
                  </div>
                </div>
              </div> -->
              <div class="item border-1px-b">
                <span class="required">*</span>
                <span class="span-title">电子邮箱</span>
                <div class="right-box">
                  <div class="cell">
                    <input
                      type="text"
                      v-model="s_email"
                      class="font-title-color right-span"
                      maxlength="100"
                      placeholder="请填写"
                      @blur="blurEvent('s_email')"
                    />
                  </div>
                </div>
              </div>
              <div class="item border-1px-b z-index-10">
                <span class="required">*</span>
                <span class="span-title">推荐机构</span>
                <div class="right-box">
                  <div class="cell select-cell" @click="clickOrgSelect()">
                    <input
                      class="select-right-box"
                      readonly="readonly"
                      type="text"
                      placeholder="请选择推荐机构"
                      v-model="orgSelectList.orgSelectText"
                    />
                    <i class="ion-arrow"></i>
                  </div>
                  <div
                    class="select-box"
                    v-show="orgSelectList.showOrgOptions"
                    @click.stop
                  >
                    <cj-scroller direction="y" :noscrollbar="true">
                      <div class="scroller-box">
                        <p
                          class="font-normal-color"
                          v-for="option in orgOptions"
                          :key="option.value"
                          @click="selectOrgOptions(option.value)"
                        >
                          {{ option.text }}
                        </p>
                      </div>
                    </cj-scroller>
                  </div>
                </div>
              </div>
              <div
                class="item border-1px-b z-index-10"
                v-show="s_recOrgan == '1' || s_recOrgan == '2'"
              >
                <span class="required">*</span>
                <span class="span-title">推荐部门</span>
                <div class="right-box">
                  <div class="cell select-cell">
                    <input
                      class="select-right-box"
                      type="text"
                      placeholder="可输入关键字搜索"
                      v-model="s_recDept"
                      @blur="departBlur()"
                      @input="getRecommendDepartment()"
                      @focus="getRecommendDepartment()"
                    />
                    <i
                      class="ion-arrow"
                      @click="
                        departSelectList.showDepartOrgOptions =
                          !departSelectList.showDepartOrgOptions
                      "
                      v-show="departSelectList.showDepartOrgOptions"
                    ></i>
                  </div>
                  <!--下拉选择box-->
                  <div
                    class="select-box"
                    v-show="departSelectList.showDepartOrgOptions"
                    @click.stop
                  >
                    <cj-scroller direction="y" :noscrollbar="true">
                      <div class="scroller-box">
                        <p
                          class="font-normal-color over-long"
                          v-for="(option, index) in departOptions"
                          :key="index"
                          @click="selectDepartOptions(option.text, index)"
                        >
                          {{ option.text }}
                        </p>
                      </div>
                    </cj-scroller>
                  </div>
                </div>
              </div>
              <div
                class="item border-1px-b"
                v-show="s_recOrgan == '1' || s_recOrgan == '2'"
              >
                <span class="required">*</span>
                <span class="span-title">推荐人</span>
                <div class="right-box">
                  <div class="cell">
                    <input
                      type="text"
                      v-model="s_recPerson"
                      maxlength="100"
                      class="font-title-color right-span"
                      placeholder="请填写"
                    />
                  </div>
                </div>
              </div>

              <!-- <div class="item border-1px-b">
                <span class="required">*</span>
                <span class="span-title" style="width: auto"
                  >是否申请美市科技提供的相关奖励</span
                >
                <div class="right-box" style="text-align: right">
                  <input
                    name="gEdition"
                    type="radio"
                    v-model="s_gEditionChecked"
                    value="1"
                    checked
                  />是
                  <input
                    name="gEdition"
                    type="radio"
                    v-model="s_gEditionChecked"
                    value="0"
                  />否
                </div>
              </div> -->
              <!-- <div class="item border-1px-b">
                <span class="required">*</span>
                <span class="span-title" style="width: auto"
                  >是否有长江证券资金账户</span
                >
                <div class="right-box" style="text-align: right">
                  <input
                    name="fundAccount"
                    type="radio"
                    v-model="s_fundAccount"
                    value="1"
                    checked
                  />是
                  <input
                    name="fundAccount"
                    type="radio"
                    v-model="s_fundAccount"
                    value="0"
                  />否
                </div>
              </div>

              <div v-show="s_fundAccount == '1'">
                <div class="item border-1px-b">
                  <span class="required">*</span>
                  <span class="span-title">资金账号为</span>
                  <div class="right-box">
                    <div class="cell">
                      <input
                        type="text"
                        v-model="s_fundCount"
                        class="font-title-color right-span"
                        maxlength="100"
                        placeholder="请填写资金账号"
                      />
                    </div>
                  </div>
                </div>

                <div>
                  <div class="item border-1px-b">
                    <span class="required">*</span>
                    <span class="span-title" style="width: auto"
                      >申请长江证券CQT、CTC交易系统服务</span
                    >
                    <div class="right-box" style="text-align: right">
                      <input
                        name="cqt"
                        type="radio"
                        v-model="s_cqtChecked"
                        value="1"
                        checked
                      />是
                      <input
                        name="cqt"
                        type="radio"
                        v-model="s_cqtChecked"
                        value="0"
                      />否
                    </div>
                  </div>
                  <div class="item border-1px-b">
                    <span class="required">*</span>
                    <span class="span-title" style="width: auto"
                      >申请FinD金融数据终端一年使用权</span
                    >
                    <div class="right-box" style="text-align: right">
                      <input
                        name="iFund"
                        type="radio"
                        v-model="s_iFundChecked"
                        value="1"
                        checked
                      />是
                      <input
                        name="iFund"
                        type="radio"
                        v-model="s_iFundChecked"
                        value="0"
                      />否
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div> -->

              <div class="item border-1px-b">
                <span class="required">*</span>
                <span class="span-title" style="width: auto"
                  >贵司近期是否有新发产品的计划</span
                >
                <div class="right-box" style="text-align: right">
                  <input
                    name="hProduct"
                    type="radio"
                    v-model="s_hProductChecked"
                    value="1"
                    checked
                  />是
                  <input
                    name="hProduct"
                    type="radio"
                    v-model="s_hProductChecked"
                    value="0"
                  />否
                </div>
              </div>
              <!-- <div class="item border-1px-b">
                <span class="required">*</span>
                <span class="span-title" style="width: auto"
                  >申请FinD金融数据终端</span
                >
                <div class="right-box" style="text-align: right">
                  <input
                    name="iFund"
                    type="radio"
                    v-model="s_iFundChecked"
                    value="1"
                    checked
                  />是
                  <input
                    name="iFund"
                    type="radio"
                    v-model="s_iFundChecked"
                    value="0"
                  />否
                </div>
              </div> -->
              <div class="item border-1px-b" style="height: px2rem(25px)">
                <span class="required">*</span>
                <span class="span-title" style="width: auto">感兴趣的业务</span>
              </div>
              <div class="busi-box">
                <label
                  class="busi-list"
                  v-for="(item, index) in interestedBusi"
                  :key="index"
                  ><input
                    width="10"
                    type="checkbox"
                    name="busi"
                    :value="item.busi_id"
                    @click="item.checked = !item.checked"
                    :checked="item.checked"
                  />&nbsp;{{ item.busi_name }}</label
                ><br />
              </div>
            </div>
          </div>
          <!-- 私募产品信息 -->
          <div class="sign-form">
            <!-- 标题 -->
            <h3 class="sign-from-header">私募产品信息</h3>
            <div class="list" v-for="(item, proIndex) in list" :key="proIndex">
              <div
                class="delete-icon"
                v-show="proIndex >= 1"
                @click="deleteList(proIndex)"
              >
                <span>
                  <img
                    src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwCAMAAABg3Am1AAAAn1BMVEVHcEyKioqHh4eKioqKioqJiYmKioqJiYmKioqHh4eJiYmLi4uKioqOjo6Li4uLi4uIiIiMjIyKioqJiYmKioqLi4uKioqKioqLi4uMjIyKioqPj4+JiYmKioqGhoaKioqJiYmJiYmLi4uJiYmLi4uKioqLi4uJiYmJiYmLi4uLi4uMjIyOjo6Ojo6KioqIiIiGhoaKioqKioqHh4eKiopvND0zAAAANHRSTlMAnyB4VWbfgL9AWy6OCa0LLSptdUZEpmR/NWAZTpkVrENFnLRcjKeTNEthMxIkyEkT7TAiVYnf8QAAANFJREFUSMftltcOwjAQBNMdp9F7773v/38bJSFgYuIgIQWJzIu9J8+DT9bJkpRxYaGTkOVOeHxlgOGgCIQtXpDjz68BsnnEEwH2sUIBKDznI5CPFSjAFgD6HaFcDBp5uQNDmPUKIxgQYjAC8UwB1XoKj6hlu/deMYuUa3S5goOmv2lDvy4WND9r6HAFEyToAExezoRM+EGh5o87GaWEAiW3gaoQmlB4JT1hihlfGKLHrU/gzXPRsmuP4HAF7f2YHEifGeq7UZYfqySCavX//qNwBnqLNyqVxn+dAAAAAElFTkSuQmCC"
                    alt="删除"
                    />删除
                </span>
              </div>

              <div class="item border-1px-b z-index-10">
                <span class="required">*</span>
                <span class="span-title">产品名称</span>
                <div class="right-box">
                  <div class="cell select-cell">
                    <input
                      class="select-right-box"
                      type="text"
                      placeholder="可输入产品名称搜索"
                      v-model="item.s_proName"
                      @input="getProductNameSerach(item.s_proName, proIndex)"
                      @blur="productBlur(proIndex)"
                      @focus="getProductNameSerach(item.s_proName, proIndex)"
                    />
                    <i
                      class="ion-arrow"
                      @click="item.showproductNam = !item.showproductNam"
                      v-show="item.showproductName"
                    ></i>
                  </div>
                  <!--下拉选择box-->
                  <div class="select-box" v-show="item.showproductName" @click.stop>
                    <cj-scroller direction="y" :noscrollbar="true">
                      <div class="scroller-box">
                        <p
                          class="font-normal-color over-long"
                          v-for="(option, index) in productNameList"
                          :key="index"
                          @click="selectProductName(option, proIndex)"
                        >
                          {{ option.prod_name }}
                        </p>
                      </div>
                    </cj-scroller>
                  </div>
                </div>
              </div>

              <!-- <div class="item border-1px-b">
                <span class="required">*</span>
                <span class="span-title">产品名称</span>
                <div class="right-box">
                  <div class="cell">
                    <input
                      class="select-right-box"
                      type="text"
                      placeholder="请填写"
                      v-model="item.s_proName"
                      @focus="prodFocus = true"
                    />
                  </div>
                  <div
                    class="select-box"
                    v-show="productNameList.showproductName"
                    @click.stop
                  >
                    <cj-scroller direction="y" :noscrollbar="true">
                      <div class="scroller-box">
                        <p
                          class="font-normal-color over-long"
                          v-for="(option, index) in productNameList"
                          :key="index"
                          @click="selectProductName(option,index)"
                        >
                          {{ option.prod_name }}
                        </p>
                      </div>
                    </cj-scroller>
                  </div>
                </div>
              </div> -->

              <div class="item border-1px-b z-index-10">
                <span class="required">*</span>
                <span class="span-title">产品策略</span>
                <div class="right-box">
                  <div class="cell select-cell">
                    <div v-if="item.s_proStra && item.s_proStra.length > 0" class="select-right-box" style="font-size: 12px;">
                        <!-- <input
                        class="select-right-box"
                        readonly="readonly"
                        type="text"
                        placeholder="请选择产品策略"
                        v-model="deo"
                        /> -->
                      <span v-if="item.s_proStra[0]" @click="clickProSelect(proIndex, '1', '', '')" style="width: 30%;">
                        {{ item.s_proStra[0] }}
                      </span>
                      <!-- <input
                        v-if="item.s_proStra[0] && item.s_proStra[0] == '其他策略'"
                        type="text"
                        placeholder="请填写其他策略"
                        style="width: 60%;"
                        v-model="item.s_proStra[1]"
                      /> -->
                      <span v-if="item.s_proStra[1]" @click="clickProSelect(proIndex, '2', item.s_proStra[0], '')">
                        {{ item.s_proStra[1] }}
                      </span>
                      <span v-if="item.s_proStra[2]">
                        {{ item.s_proStra[2] }}
                      </span>
                    </div>
                    <div v-else class="select-right-box" @click="clickProSelect(proIndex, '1', '', '')">
                      <span style="color: rgb(192, 196, 204);">请选择产品策略</span>
                    </div>
                    <i class="ion-arrow" @click="clickProSelect(proIndex, '1', '', '')"></i>
                  </div>
                  <!--下拉选择box-->
                  <div class="select-box" v-show="item.showProOptions" @click.stop>
                    <cj-scroller direction="y" :noscrollbar="true">
                      <div class="scroller-box">
                        <p
                          class="font-normal-color"
                          v-for="(option, selectIndex) in item.s_showProOption"
                          :key="selectIndex"
                          @click="selectProOptions(proIndex, selectIndex, option)"
                        >
                          {{ option.ReturnStrategyName }}
                        </p>
                      </div>
                    </cj-scroller>
                  </div>
                </div>
              </div>

              <!-- <div class="item border-1px-b z-index-10">
                <span class="required">*</span>
                <span class="span-title">产品策略类型</span>
                <div class="right-box">
                  <div class="cell select-cell" @click="clickGroupSelect(proIndex)">
                    <input
                      class="select-right-box"
                      readonly="readonly"
                      type="text"
                      placeholder="请选择产品策略"
                      v-model="item.s_GroStra"
                    />
                    <i class="ion-arrow"></i>
                  </div>
                  <div class="select-box" v-show="item.showGroOptions" @click.stop>
                    <cj-scroller direction="y" :noscrollbar="true">
                      <div class="scroller-box">
                        <p
                          class="font-normal-color"
                          v-for="(option, selectIndex) in groupOptions"
                          :key="selectIndex"
                          @click="selectGroupOptions(proIndex, selectIndex)"
                        >
                          {{ option.strategy_name }}
                        </p>
                      </div>
                    </cj-scroller>
                  </div>
                </div>
              </div> -->

              <div class="item border-1px-b">
                <span class="required">*</span>
                <span class="span-title">产品备案编号</span>
                <div class="right-box">
                  <div class="cell">
                    <input
                      type="text"
                      v-model="item.s_proNum"
                      maxlength="100"
                      class="font-title-color right-span pro-inp"
                      placeholder="选择产品后自动填充"
                      @blur="blurProNum(proIndex, $event)"
                      :disabled="item.s_proNum ? true : false"
                    />
                  </div>
                </div>
              </div>
              <div class="item border-1px-b">
                <span class="required">*</span>
                <span class="span-title">产品管理规模</span>
                <div class="right-box">
                  <div class="cell product-unit">
                    <input
                      type="text"
                      v-model="item.s_mamScale"
                      maxlength="100"
                      class="font-title-color right-span"
                      placeholder="请填写"
                    />
                    <span class="unit">万元(CNY)</span>
                  </div>
                </div>
              </div>
              <div class="item border-1px-b">
                <span class="required">*</span>
                <span class="span-title">基金经理姓名</span>
                <div class="right-box">
                  <div class="cell">
                    <input
                      type="text"
                      v-model="item.s_manName"
                      maxlength="100"
                      class="font-title-color right-span"
                      placeholder="请填写"
                    />
                  </div>
                </div>
              </div>
              <!-- <div class="item border-1px-b">
                <span class="required">*</span>
                <span class="span-title" style="width: auto"
                  >是否授权获取第三方数据(聚源、私募排排网)</span
                >
                <div class="right-box" style="text-align: right">
                  <input
                    :name="`netWorth` + proIndex"
                    type="radio"
                    v-model="item.s_netWorth"
                    value="1"
                    checked
                  />是
                  <input
                    :name="`netWorth` + proIndex"
                    type="radio"
                    v-model="item.s_netWorth"
                    value="0"
                  />否
                </div>
              </div> -->
              <!-- 是/否 -->
              <!-- <div class="item border-1px-b">
                <span class="required">*</span>
                <span class="span-title" style="width: auto"
                  >该产品是否在长江开户</span
                >
                <div class="right-box" style="text-align: right">
                  <input
                    :name="openAccList[proIndex].name"
                    type="radio"
                    v-model="item.s_openChecked"
                    value="1"
                    checked
                  />是
                  <input
                    :name="openAccList[proIndex].name"
                    type="radio"
                    v-model="item.s_openChecked"
                    value="0"
                  />否
                </div>
              </div>
              <div class="item border-1px-b" v-show="item.s_openChecked == '1'">
                <span class="required">*</span>
                <span class="span-title">资金账户</span>
                <div class="right-box">
                  <div class="cell">
                    <input
                      type="text"
                      v-model="item.s_moneyCount"
                      class="font-title-color right-span"
                      maxlength="100"
                      placeholder="请填写"
                    />
                  </div>
                </div>
              </div> -->
            </div>
            <div class="list">
              <div class="add-entries-btn" @click="addProInfo()">
                +点击添加参赛产品
              </div>
              <p class="note-text"></p>
            </div>
          </div>
          <!-- 阅读协议 -->
          <div class="agreement">
            <input type="checkbox" class="agr-inp" v-model="s_amtCheck" />
            <span>我已阅读并同意</span>
            <!-- <a class="file" @click="showSpikePopup.promise = true"
              >《参赛机构承诺书》</a
            > -->
            <a class="file" @click="showSpikePopup.escape = true">《免责声明》</a>
            <cj-popup
              v-model="showSpikePopup.promise"
              :noclose="false"
              type="normal"
            >
              <div class="agrHint">
                <div class="title">参赛承诺书</div>
                本机构自愿参加长江证券股份有限公司主办、兴业银行联合主办（以下统称“主办方”），证券时报、券商中国、金航母协办（以下简称“协办方”）的私募大赛，，并已经充分、仔细地阅读、理解并完全接受本次大赛规则以及本确认书内容，在此谨向主办方及协办方承诺并确认如下：
                <br />
                1、本机构已阅读、理解并自愿遵守主办方指定官网、媒体上公布的本次大赛的规则。
                <br />
                2、本机构同意大赛主办方及协办方在合规范围内查看并使用本机构发送至大赛相关平台或授权渠道展示的产品信息（公司资料、产品资料、产品净值等），并承诺相关信息及数据均合法、真实、准确、完整和有效，对于申报的信息及数据不符合要求的，单方面取消本机构管理的相应产品的参赛资格。
                <br />
                3、本机构同意授权赛事主办方将参赛产品排名信息披露给第三方媒体等机构，用于本次活动的排名信息展示。本机构承诺完全同意并认可排名信息在公共媒体进行披露。
                <br />
                4、本机构承诺自负盈亏，所有投资及交易行为将严格遵守各项法律法规及监管要求，依法合规地参与本次私募大赛，如在参赛期间出现负面舆情，同意主办方根据实际情况单方面取消本机构管理的相应产品的参赛资格。
                <br />
                5、本机构同意主办方有权对大赛规则进行解释、更改、增加或删除，更改或增加的规则将作为大赛规则不可分割的一部分；主办方有权基于不可抗力、情势变更或政府部门的相关规定、通知、命令随时终止大赛，不得因此向主办方主张任何法律或经济上的权利。
                <br />
                6、本机构将自行妥善保管参赛账户与密码，如因参赛账户或密码被盗所导致的资产受损或大赛排名结果受影响，大赛主办方不承担任何责任。
                <br />
                7、本机构承诺参赛前已核实并确保参赛金融产品的投资及交易策略、范围等与产品合同保持一致，不存在违法违规以及侵犯任何第三方权益的情况，不存在违反产品合同约定的情况。
                <br />
                8、本次大赛披露的排名等相关信息仅限大赛范围参考，不构成对任何主体的投资建议；大赛主办方接受参赛机构参与本次大赛，不代表大赛主办方或协办方对参赛机构及其管理的基金产品的推荐、营销、宣传，不代表主办方或协办方与参赛机构之间存在基金产品销售委托代理关系。本机构不得利用主办方或协办方的名义、商标、商号或者本次大赛名义进行基金宣传、募集活动；对未经大赛主办方授权不当使用相关信息造成的任何后果，与大赛主办方无关。
                <br />
                9、本机构承诺了解本次大赛关于获奖权益的相关规定和要求，知晓最终获得获奖权益需符合相关要求。
                <br />
                10、本次大赛最终解释权归主办方所有，大赛主办方有权根据实际情况进行修改或取消。
                <br />
                本机构已详细阅读并完全理解上述全部内容。本机构已确认、同意，并将积极配合，同时愿意承担因违反上述条款而产生的风险和损失。
              </div>
            </cj-popup>
            <cj-popup
              v-model="showSpikePopup.escape"
              :noclose="false"
              type="normal"
            >
              <div class="agrHint">
                <div class="title">风险免责声明</div>
                （一）本次活动接受报名机构报名，不代表主办方或协办方对报名机构及其管理的基金产品的推荐、营销、宣传，不代表主办方或协办方与报名机构之间存在基金产品销售委托代理关系。报名机构不得利用主办方的名义、商标、商号或者本次计划名义进行基金宣传、募集活动。
                <br />
                （二）如报名方未按要求报名、未及时报送数据、数据或信息有误等，活动主办方不承担任何责任。
                <br />
                （三）本次活动所涉及的报名及活动权益，需符合主办方及协办方相关管理制度，不构成服务承诺。
                <br />
                （四）本次活动的最终解释权归主办方所有。
              </div>
            </cj-popup>
          </div>
          <!-- </div> -->
          <!-- 日期选择器 -->
          <mt-datetime-picker
            ref="startPicker"
            :startDate="startDate"
            :endDate="endDate"
            type="date"
            year-format="{value} 年"
            month-format="{value} 月"
            date-format="{value} 日"
            :close-on-click-modal="false"
            @confirm="handleConfirm"
            @cancel="handleCancel"
          />
      </div>
      <div v-else class="all-boxs">
        <div class="all-table">
          <div class="all-table-th">
            <div class="all-table-th-td">产品名称</div>
            <div class="all-table-th-td">产品备案编号</div>
            <div class="all-table-th-td">产品策略</div>
            <div class="all-table-th-td">最新净值日期</div>
            <div class="all-table-th-td">已读取周数</div>
            <div class="all-table-th-td">近一年同策略收益率分位</div>
            <div class="all-table-th-td">近一年同策略最大回撤分位</div>
            <div class="all-table-th-td">数据状态</div>
            <div class="all-table-th-td">操作</div>
          </div>
          <div v-for="(item, index) in baomingData" :key="index" class="all-table-tr">
            <div class="all-table-tr-td">{{ item.prod_name }}</div>
            <div class="all-table-tr-td">{{ item.prod_record_num }}</div>
            <div class="all-table-tr-td">{{ item.prod_strategy }}</div>
            <div class="all-table-tr-td" :class="[item.if_last_week_day == '0' ? 'if_last_week':'']">{{ item.last_nav_date }}</div>
            <div class="all-table-tr-td">{{ item.week_read_num }}</div>
            <div class="all-table-tr-td">{{ item.yield_rate }}</div>
            <div class="all-table-tr-td">{{ item.maximum_drawdown_rate }}</div>
            <div class="all-table-tr-td" style="color: red;">{{ statuFilter(item.data_status)  }}</div>
            <div class="all-table-tr-td" style="color: #1890ff;" @click="deleteOne(item)">删除</div>
          </div>
          <div class="tabfz">
            <!-- <span style="color: red;">净值报送字段：</span>产品名称（与公示数据保持一致）、基协备案编号、单位净值、累计单位净值、产品资产净值。
            <br />
            <span style="color: red;">净值报送要求：</span>报名产品需通过托管人或外包机构专用邮箱发送产品成立以来每周及每月最后一个交易日的历史数据至赋能计划指定邮箱<span style="color: blue;">jcjfnjh@pbcjsc.com</span>，同时订阅后续净值数据自动发送，并承诺净值数据真实、准确、可查。
            <br />
            <span style="color: red;">报名状态说明：</span>提交报名信息后，需将净值邮件发送至指定邮箱，净值数据将自动解析并于次日将报名状态更新至当前页面。 -->
          </div>
        </div>
      </div>
    </div>
    <div v-if="tabflag === '1'"
      class="footer"
      style="
        background-image: linear-gradient(0deg, #e7620a 0%, #f1a970 100%);
        color: white;
      "
    >
      <button @click="submit()" style="color: white">提交</button>
    </div>
    <mt-popup
      v-model="showPopup"
      class="sign-up-popup"
      popup-transition="popup-fade"
      :close-on-click-modal="false"
    >
      <div class="common-popup-box">
        <i class="close-popup-icon" @click="showPopup = false"></i>
        <h3 class="popup-title" v-show="isSuccess">提交成功</h3>
        <h3 class="popup-title" v-show="!isSuccess">提交失败</h3>
        <div class="popup-contend">
          <p v-show="!isSuccess">{{ errorMsg }}</p>
          <div class="img success-img" v-show="isSuccess">
            <!-- <img src="../assets/succeed.png" alt /> -->
            <div style="font-size: 14px;text-align: left;color: rgb(204, 154, 93);">
              恭喜您已成功提交报名，点击下载<span style="color: #1890ff;" @click="downloadPDF">赋能计划专属合格投资者认证材料</span>，
              订阅周频+月频+历史净值数据（excel格式）至赋能计划数据接收邮箱
              jcjfnjh@pbcjsc.com。
            </div>
          </div>
          <div class="img failure-img" v-show="!isSuccess">
            <img src="../assets/lose.png" alt />
          </div>
          <div class="confirm-btn" @click="closeTips()">确认</div>
        </div>
      </div>
    </mt-popup>
    <mt-popup
      v-model="showRegStatus"
      class="sign-up-popup"
      popup-transition="popup-fade"
      :close-on-click-modal="false"
    >
      <div class="common-popup-box">
        <i class="close-popup-icon" @click="showRegStatus = false"></i>
            <!-- <img src="../assets/succeed.png" alt /> -->
            <div style="font-size: 14px;text-align: left;color: rgb(204, 154, 93);">
              尊敬的管理人您好，贵司有产品尚未完成报名流程，请下载<span style="color: #1890ff;" @click="downloadPDF">赋能计划专属合格投资者认证材料</span>，订阅周频+月频+历史净值数据（excel格式）至赋能计划数据接收邮箱jcjfnjh@pbcjsc.com。
            </div>
      </div>
    </mt-popup>
  </div>
</template>

<script>
import { cjScroller, cjPopup } from "components";
import { Toast } from "mint-ui";
import cjServices from "../services/cjServices.js";
import nativeService from "../services/common/nativeService.js";
const STATUS_MAP = {
  '0': '未满一年',
  '1': '请报送',
  '2': '请补充',
  '3': '成功'
}
export default {
  components: {
    cjScroller,
    cjPopup,
  },
  data() {
    return {
      org_name: '', // 机构简称
      baomingData: [],
      tabflag: '1', // 1:私募数据报名；2：私募产品数据
      code_err: '',
      goldCJToken: '', // 登陆后的token
      isSpecial: false, // true: 专业投资者， false: 私募产品组
      // 是否展示推荐部门下拉框
      departSelectList: {
        showDepartOrgOptions: false,
        departSelectText: "",
      },
      // 协会编号
      manageScaleList: {
        showDepartOrgOptions: false,
        departSelectText: "",
      },
      departmentIndex: null,
      manageIndex: null,
      proNameIndex: null,
      departmentFocus: true,
      manageScaleFocus: true,
      prodFocus: true,
      // 推荐机构相关数据
      orgSelectList: {
        // 是否展示推荐机构下拉框
        showOrgOptions: false,
        // 选中展示文本
        orgSelectText: "",
      },
      // 弹框
      showSpikePopup: {
        promise: false,
        escape: false,
      },
      // 专业投资者信息
      z_name: "",
      z_account: "",
      z_mobile: "",
      z_imgsrc: "",
      z_validateCode: "",
      z_smsCode: "",
      z_email: "",
      z_recDept: "",
      z_recPerson: "",
      z_sessionId: "",
      // 短信发送成功后返回的验证码和短信序列号
      z_verifyCode: "",
      z_serialNo: "",
      s_verification: "获取验证码",
      // 短信计时器
      z_count: 0,
      // s_fundAccount: "0",
      z_cqtChecked: 0,
      z_iFundChecked: 0,
      z_gEditionChecked: 0,
      // 资金账户
      // s_fundCount: "",
      // 私募产品组信息
      // 开始日期
      startDate: new Date(1980, 0, 1),
      endDate: new Date(),
      // 选中的开始日期
      s_selectDate: "",
      // 是否展示提交成功、失败提示弹窗
      showPopup: false,
      isSuccess: false,
      // 验证码图片
      s_imgsrc: "",
      s_sessionId: "",
      s_mobile: "",
      s_validateCode: "",
      s_smsCode: "",

      // 短信发送成功后返回的验证码和短信序列号
      s_verifyCode: "",
      s_serialNo: "",
      // 短信计时器
      s_count: 0,
      s_organName: "",
      s_manageScale: "",
      s_assoNum: "",
      s_dateValue: "",
      s_name: "",
      s_position: "",
      s_email: "",
      s_recOrgan: "",
      s_recPerson: "",
      // 产品名称
      s_proName: "",
      // 产品编号
      s_proNum: "",
      // 是否有长江证券资金账户
      s_capitalAccount: 0,
      // 私人部门
      s_recDept: "",
      // s_cqtChecked: 0,
      s_iFundChecked: 0,
      s_amtCheck: false,
      s_gEditionChecked: 0,
      s_hProductChecked: 0,
      openAccList: [
        { name: "openaccount1" },
        { name: "openaccount2" },
        { name: "openaccount3" },
        { name: "openaccount4" },
        { name: "openaccount5" },
      ],
      // 1-长江证券 2-长江期货 3-兴业银行 4-证券时报 5-券商中国 6-同花顺 7-其他
      orgOptions: [
        { text: "长江证券", value: "1" },
        { text: "长江期货", value: "2" },
        { text: "兴业银行", value: "3" },
        { text: "证券时报", value: "4" },
        // { text: "同花顺", value: "6" },
        // { text: "美市科技", value: "8" },
        // { text: "云纪网络", value: "9" },
        // { text: "私募排排网", value: "10" },
        // { text: "卡方科技", value: "11" },
        // { text: "华锐科技", value: "12" },
        { text: "其他", value: "7" },
      ],
      productNameList: [],
      manageScaleOptions: [],
      departOptions: [],
      // 专业
      zdepartOptions: [],
      // 私人
      sdepartOptions: [],
      proOptions: [],
      groupOptions: [],
      // 感兴趣业务
      interestedBusi: [],
      proNameCoyp: [],
      interestedlist: "",
      // 机构类型
      organizationType: "",
      // 参赛产品策略相关数据
      list: [
        {
          // 是否展示产品名称下拉框
          showproductName: false,
          // 是否展示产品策略下拉框
          showGroOptions: false,
          // s_GroStra: "",
          showProOptions: false,
          s_proStra: [],
          s_showProOption: [],
          // s_firPro: [],
          // s_secPro: [],
          // s_thiPro: [],
          s_proName: "",
          s_proNum: "",
          s_mamScale: "",
          s_manName: "",
          s_netWorth: 0,
          // 是否开户
          // s_openChecked: 0,
          // 资金账户
          // s_moneyCount: "",
        },
      ],
      setTimer: null,
      setsTimer: null,
      errorMsg: "",
      // 是否展示未报名成功提示
      showRegStatus:false
    };
  },
  watch: {
    // s_recDept: {
    //   handler(newVal, oldVal) {
    //     if (this.departmentFocus && newVal && newVal != oldVal) {
    //       this.getRecommendDepartment(newVal);
    //     }
    //   },
    // },
    z_recDept: {
      handler(newVal, oldVal) {
        if (this.departmentFocus && newVal && newVal != oldVal) {
          this.getRecommendDepartment();
        }
      },
    },
    // s_manageScale: {
    //   handler(newVal, oldVal) {
    //     if (this.manageScaleFocus && newVal && newVal != oldVal) {
    //       this.getOrganizationName(newVal);
    //     }
    //   },
    // },
  },
  created() {
    const goldCJToken = window.sessionStorage.getItem('goldCJToken')
    if (!goldCJToken) {
      this.$router.replace("/login")
    } else {
      this.goldCJToken = goldCJToken
    }
    // 两个图形验证码初始化
    if (navigator.userAgent.indexOf("cjsccjeh") > -1) {
      nativeService.closeNativeBtn("hide");
    }
    this.getValidateImg(true);
    this.getValidateImg(false);
    // 产品策略组字典
    // this.getPolicyGroup('1', '', '');

    this.getProData()
    // 感兴趣业务
    this.getInterested();

    setTimeout(() => {
      // 回显私募机构信息
       this.showProData()
    }, 200);
  },
  mounted () {
    this.getRecommendDepartment = this.debounce(this.getRecommendDepartments, 800)
  },
  methods: {
    statuFilter(flag) {
      return STATUS_MAP[flag]
    },
    downloadPDF() {
      // this.MessageBox.confirm('是否下载长江证券合格投资者认证材料?').then(action => {
      //   if (action == 'confirm') {
      let url = 'https://regard01.95579.com/cjscweb/web/goldcj/rzcl20250618152522.pdf'
      if (this.env == 'pro') {
        url = 'https://u.95579.com/cjscweb/web/goldcj/rzcl20250618152522.pdf'
      }
      const link = document.createElement('a');
      link.href = url;
      link.download = '长江证券合格投资者认证材料.pdf'; // 设置下载的文件名
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      //   }
      // });
    },
    showProData() { // 回显报名信息数据
      const params = {
        "goldCJToken": this.goldCJToken
      }
      cjServices.showProData(this, params).then(res => {
        if (res.body.error_code === '-9999') {
          this.$router.replace("/login")
          return
        }
        if (res.body.error_code === '0') {
          const huixianShow = res.body.results || []
          if(huixianShow.length > 0) {
            const oneObj = huixianShow[0]
            this.s_manageScale = oneObj['asso_regist_num']
            this.org_name = oneObj['org_name']
            this.s_name = oneObj['contact_name']
            this.s_position = oneObj['contact_position']
            this.s_organName = oneObj['organ_full_name']
            this.s_selectDate = oneObj['establish_date']
            this.s_assoNum = oneObj['organ_scale']
            this.s_email = oneObj['email']
            this.s_recOrgan = oneObj['recommend_organ']
            this.orgSelectList.orgSelectText = this.orgOptions.filter(v => v.value == oneObj['recommend_organ'])[0]['text']
            this.s_hProductChecked = oneObj['new_product']
            this.s_recDept = oneObj['recommend_dept']
            this.s_recPerson = oneObj['recommend_person']
            if (oneObj['interested_busi']) {
              const intest = oneObj['interested_busi'].split(',')
              this.interestedBusi.forEach(v => {
                if (intest.indexOf(v.busi_id) > -1) {
                  v['checked'] = true
                }
              })
            }
            this.$forceUpdate()
          }
        }
      })
      this.getManagerRegStatus()
    },
    getManagerRegStatus() { // 回显报名信息数据
      const params = {
        "goldCJToken": this.goldCJToken
      }
      cjServices.getManagerRegStatus(this, params).then(res => {
        if (res.body.error_code === '-9999') {
          this.$router.replace("/login")
          return
        }
        if (res.body.error_code === '0') {
          const StatusShow = res.body.results || []
          if(StatusShow.length > 0) {
            const reg_status = StatusShow[0].reg_status
            if(reg_status == '0') {
              this.tabflag = '2'
              this.showRegStatus = true;
            }
            // console.log(222222, reg_status);
          }
        }
      })
    },
    deleteOne(item) { // 删除对应产品数据
      const params = {
        "goldCJToken": this.goldCJToken,
        "i_prod_record_num": item.prod_record_num
      }
      cjServices.deleteOneProData(this, params).then(res => {
        if (res.body.error_code === '-9999') {
          this.$router.replace("/login")
          return
        }
        if (res.body.error_code === '0') {
          this.getProData()
        }
      })
    },
    tabChange () {
      this.tabflag = '2'
      this.getProData()
    },
    getProData () { // 获取产品数据
      const params = {
        "goldCJToken": this.goldCJToken
      }
      cjServices.getNewProData(this, params).then(res => {
        if (res.body.error_code === '-9999') {
          this.$router.replace("/login")
          return
        }
        if (res.body.error_code === '0') {
          this.baomingData = res.body.results || []
        }
      })
    },
    // 产品策略组字典
    getPolicyGroup(num, fname, sname, proIndex) {
      const params = {
        "i_stra_class": num,
        "i_first_stra_name": fname,
        "i_second_stra_name": sname
      };
      cjServices.newPolicyGroups(this, params).then((response) => {
        if (response.body && response.body.error_code == "0") {
          let result = response.body.results;
          if (result && result.length > 0) {
            this.list[proIndex]['s_proStra'] = this.list[proIndex]['s_proStra'].slice(0, num)
            this.list[proIndex]['s_showProOption'] = result.map(v => ({
              nums: num,
              ...v
            }));
            this.list[proIndex].showProOptions = true;
          } else {
            this.list[proIndex].showProOptions = false;
          }
          // this.groupOptions = result;
          this.$forceUpdate();
        } else {
          Toast({
            message: response.body.error_info,
            duration: 2000,
          });
        }
      });
    },

    // 点击推荐机构选择栏
    clickOrgSelect() {
      this.orgSelectList.showOrgOptions = !this.orgSelectList.showOrgOptions;
    },

    // 点击推荐机构下拉框
    selectOrgOptions(value) {
      this.orgSelectList.showOrgOptions = false;
      this.orgOptions.forEach((v) => {
        if (v.value == value) {
          this.orgSelectList.orgSelectText = v.text;
        }
      });
      this.s_recOrgan = value;
      this.s_recPerson = "";
      this.s_recDept = "";
    },

    // 机构名称搜索
    getOrganizationName(s_organName) {
      this.manageScaleOptions = [];
      this.manageScaleFocus = true;
      this.list.forEach((item) => {
        item.s_proName = "";
        item.s_proNum = "";
      });
      if (s_organName == "") {
        this.s_manageScale = "";
        this.s_selectDate = "";
        this.s_assoNum = "";
        this.org_name = ''
      }
      this.manageScaleList.showDepartOrgOptions = false;
      const data = {
        // i_asso_regist_num: s_manageScale,
        goldCJToken: this.goldCJToken,
        i_organ_full_name: s_organName
      };
      if (this.setsTimer) clearTimeout(this.setsTimer);
      this.setsTimer = setTimeout(() => {
        cjServices.cjRaceManage(this, data).then(function (response) {
          if (response.body && response.body.error_code == "0") {
            let result = response.body.results;
            if (result.length > 0) {
              this.manageScaleOptions = result;
              this.manageScaleList.showDepartOrgOptions = true;
            }
          } else {
            Toast({
              message: response.body.error_info,
              duration: 2000,
            });
          }
        });
      }, 300);
    },

    manageScaleBlur() {
      this.manageScaleFocus = false;
      setTimeout(() => {
        if (this.manageIndex === null) {
          this.manageScaleList.showDepartOrgOptions = false;
          let s_mange = this.manageScaleOptions.some((v) => {
            return v.asso_regist_num == this.s_manageScale;
          });
          this.s_manageScale = s_mange ? this.s_manageScale : "";
          this.s_organName = s_mange ? this.s_organName : "";
          this.org_name = s_mange ? this.org_name : "";
          this.s_selectDate = s_mange ? this.s_selectDate : "";
          this.s_assoNum = s_mange ? this.s_assoNum : "";
          if (!s_mange) {
            this.list.forEach((item) => {
              item.s_proName = "";
              item.s_proNum = "";
            });
          } else {
            this.manageScaleOptions.forEach((item) => {
              if (this.s_manageScale == item.asso_regist_num) {
                this.selectScaleOptions(item);
              }
            });
          }
        }
        this.manageIndex = null;
      }, 100);
    },

    // 推荐部门失去焦点
    departBlur() {
      this.departmentFocus = false;
      setTimeout(() => {
        if (this.departmentIndex === null) {
          this.departSelectList.showDepartOrgOptions = false;
          let s_recDept_show = this.departOptions.some((v) => {
            return v.text == this.s_recDept;
          });
          let z_recDept_show = this.zdepartOptions.some((v) => {
            return v.value == this.z_recDept;
          });
          // this.s_recDept =  ''
          //  this.z_recDept = ''
          this.s_recDept = s_recDept_show ? this.s_recDept : "";
          this.z_recDept = z_recDept_show ? this.z_recDept : "";
        }
        this.departmentIndex = null;
      }, 100);
    },

    // 产品名称失去焦点
    productBlur(index) {
      this.prodFocus = false;
      setTimeout(() => {
        if (this.proNameIndex === null) {
          this.list[index].showproductName = false;
          this.proNameCoyp[index] = this.productNameList.some((v) => {
            return v.prod_name == this.list[index].s_proName;
          });
          this.list[index].s_proName = this.proNameCoyp[index]
            ? this.list[index].s_proName
            : "";
          this.list[index].s_proNum = this.proNameCoyp[index]
            ? this.list[index].s_proNum
            : "";
        }
        this.list.forEach((item, i) => {
          if (
            i != index &&
            this.list[index].s_proName &&
            item.s_proName &&
            this.list[index].s_proName == item.s_proName
          ) {
            Toast({
              message: "同一个产品不能加入不同的组或多个相同的组",
              duration: 1000,
            });
            this.list[index].s_proName = "";
            this.list[index].s_proNum = "";
            return false;
          }else{
            if(this.proNameCoyp[index]){
              this.productNameList.forEach((item) => {
              if (this.list[index].s_proName == item.prod_name) {
                this.selectProductName(item,index);
              }
            });
            }
          }
        });
        this.proNameIndex = null;
      }, 100);
    },

    selectProductName(item, index) {
      this.proNameIndex = index;
      this.list[index].s_proName = item.prod_name;
      this.list[index].s_proNum = item.prod_record_num;
      this.list[index].showproductName = false;
    },

    selectScaleOptions(item) {
      this.manageIndex = "1";
      this.manageScaleList.showDepartOrgOptions = false;
      this.s_manageScale = item.asso_regist_num;
      this.s_organName = item.organ_full_name;
      this.org_name = item.org_name
      // console.log(item.establish_date, 22333);
      this.s_selectDate = this.formatDateStr(item.establish_date);
      this.s_assoNum = item.organ_scale;
    },

    selectDepartOptions(value, index) {
      this.departSelectList.showDepartOrgOptions = false;
      this.departmentIndex = index;
      this.departSelectList.departSelectText = value;
      // 2 专
      if (this.isSpecial) {
        this.z_recDept = value;
      } else {
        this.s_recDept = value;
      }
    },
    // 点击产品所选组别选择栏
    clickGroupSelect(proIndex) {
      this.list[proIndex].showGroOptions = !this.list[proIndex].showGroOptions;
    },
    // 点击产品所选组别下拉框
    // selectGroupOptions(proIndex, selectIndex) {
    //   this.list[proIndex].showGroOptions = false;
    //   for (let i = 0; i < this.list.length; i++) {
    //     if (
    //       i != proIndex &&
    //       this.list[i].s_GroStra == this.groupOptions[selectIndex].strategy_name
    //     ) {
    //       Toast({
    //         message: "一个组别仅允许一只组别参赛",
    //         duration: 1000,
    //       });
    //       return false;
    //     }
    //   }
    //   this.list[proIndex].s_GroStra =
    //     this.groupOptions[selectIndex].strategy_name;
    // },
    // 点击产品策略选择栏
    clickProSelect(proIndex, num, firname, secname) {

      // this.list[proIndex].showProOptions = !this.list[proIndex].showProOptions;
      this.list[proIndex].showProOptions = true;
      this.getPolicyGroup(num, firname, secname, proIndex)
    },
    // 点击产品策略下拉框
    selectProOptions(proIndex, selectIndex, option) {
      // this.list[proIndex].showProOptions = false;
      this.list[proIndex].showProOptions = option['flag'] == '1' ? true : false;

      // for (let i = 0; i < this.list.length; i++) {
      //   if (
      //     i != proIndex &&
      //     this.list[i].s_proStra == this.proOptions[selectIndex].strategy_name
      //   ) {
      //     Toast({
      //       message: "一个策略仅允许一只产品参赛",
      //       duration: 1000,
      //     });
      //     return false;
      //   }
      // }
      const nums = option['nums'] - 1
      this.list[proIndex].s_proStra[nums] = this.list[proIndex]['s_showProOption'][selectIndex].ReturnStrategyName;
      if (!this.list[proIndex].showProOptions) {
        console.log(66633333, this.list, proIndex, option)
        return
      }
      if (option['nums'] == 1) {
        // if (this.list[proIndex]['s_showProOption'][selectIndex].ReturnStrategyName == '其他策略') {
        //   this.list[proIndex].s_proStra[1] = ''
        // }
        this.clickProSelect(proIndex, '2', this.list[proIndex].s_proStra[0], '')
      } else if (option['nums'] == 2) {
        this.clickProSelect(proIndex, '3', this.list[proIndex].s_proStra[0], this.list[proIndex].s_proStra[1])
      }
    },
    blurEvent(type) {
      if (type == "s_email") {
        if (this.s_email != "" && !cjServices.checkEmail(this.s_email)) {
          Toast({
            message: "请输入正确的电子邮箱",
            duration: 1000,
          });
          return false;
        }
      }
      if (type == "z_email") {
        if (this.z_email != "" && !cjServices.checkEmail(this.z_email)) {
          Toast({
            message: "请输入正确的电子邮箱",
            duration: 1000,
          });
          return false;
        }
      }
      if (type == "s_mobile") {
        if (this.s_mobile != "" && !cjServices.checkMobile(this.s_mobile)) {
          Toast({
            message: "请输入正确的手机号码",
            duration: 1000,
          });
          return false;
        }
      }
      if (type == "z_mobile") {
        if (this.z_mobile != "" && !cjServices.checkMobile(this.z_mobile)) {
          Toast({
            message: "请输入正确的手机号码",
            duration: 1000,
          });
          return false;
        }
      }
    },
    blurProNum(index, event) {
      if (this.list[index].s_proNum != "") {
        this.list.forEach((v, i) => {
          if (i != index && this.list[index].s_proNum == v.s_proNum) {
            Toast({
              message: "每只产品仅可以选择一个组别参赛",
              duration: 1000,
            });
            this.list[index].s_proNum = "";
            event.target.focus();
          }
        });
      }
    },
    getValidateImg: function (flag) {
      cjServices.getValidateImg(this).then(function (response) {
        if (response.body && response.body.error_code == "0") {
          if (flag) {
            this.z_imgsrc =
              "data:image/png;base64," + response.body.results.base64Str;
            this.z_sessionId = response.body.results.sessionId;
          } else {
            this.s_imgsrc =
              "data:image/png;base64," + response.body.results.base64Str;
            this.s_sessionId = response.body.results.sessionId;
          }
        } else {
          alert(response.body.error_info);
        }
      });
    },
    goBack() {
      nativeService.routerRedirect(-1, this);
    },
    sendMsg: function (mobile, sessionId, validateCode, flag) {
      if (!mobile) {
        Toast({
          message: "请输入联系人手机号",
          duration: 2000,
        });
        return false;
      } else if (!cjServices.checkMobile(mobile)) {
        Toast({
          message: "输入手机号格式不正确",
          duration: 2000,
        });
        return false;
      }
      if (!validateCode) {
        Toast({
          message: "请输入图形验证码",
          duration: 2000,
        });
        return false;
      }
      if (flag && this.z_count > 0) {
        return false;
      }
      if (!flag && this.s_count > 0) {
        return false;
      }
      cjServices
        .sendCode(this, {
          sessionId: sessionId,
          validateCode: validateCode,
          i_mobile: mobile,
        })
        .then(function (response) {
          if (response.body && response.body.error_code == "0") {
            Toast({
              message: "短信验证码发送成功",
              duration: 2000,
            });
            // 刷新图形验证码
            // this.getValidateImg(flag);
            if (flag) {
              this.z_validateCode = validateCode;
              this.z_serialNo =
                response.body.results.length > 0
                  ? response.body.results[0].serial_no
                  : "";
              this.z_count = 60;
              let _this = this;
              var z_timer = setInterval(function () {
                _this.$refs.z_countdown.innerText = _this.z_count + "s";
                if (_this.z_count-- <= 0) {
                  _this.z_count = 0;
                  _this.$refs.z_countdown.innerText = "获取验证码";
                  clearInterval(z_timer);
                }
              }, 1000);
            } else {
              this.s_validateCode = validateCode;
              this.s_serialNo =
                response.body.results.length > 0
                  ? response.body.results[0].serial_no
                  : "";
              this.s_count = 60;
              let _this = this;
              var s_timer = setInterval(function () {
                _this.s_verification = _this.s_count + "s";
                if (_this.s_count-- <= 0) {
                  _this.s_count = 0;
                  _this.s_verification = "获取验证码";
                  clearInterval(s_timer);
                }
              }, 1000);
            }
          } else {
            Toast({
              message: response.body.error_info,
              duration: 2000,
            });
            return false;
          }
        });
    },
    // 推荐部门
    getRecommendDepartments() {
      const s_recDept = this.s_recDept ? this.s_recDept : "";
      this.departOptions = [];
      this.departmentFocus = true;
      if (this.orgSelectList.orgSelectText == "长江证券") {
        this.organizationType = "1";
      } else if (this.orgSelectList.orgSelectText == "长江期货") {
        this.organizationType = "2";
      }
      this.departSelectList.showDepartOrgOptions = false;
      let reqData = {
        i_fzjg: s_recDept,
        i_type: this.organizationType,
      };
      reqData = this.trimObj(reqData);
      cjServices.departSerach(this, reqData).then(function (response) {
        if (response.body && response.body.error_code == "0") {
          let result = response.body.results;
          if (result.length > 0) {
            this.departSelectList.showDepartOrgOptions = true;
            let selectArray = null;
            selectArray = result.map((l) => {
              return {
                text: l.fzjg,
              };
            });
            if (selectArray.length > 5) {
              selectArray = selectArray.slice(0, 5);
              this.isPerson(selectArray);
            } else {
              this.isPerson(selectArray);
            }
          }
        } else {
          alert(response.body.error_info);
        }
      });
    },
    debounce (func, delay = 1000, immediate = false) {
      let timer = null
      //不能用箭头函数
      return function () {
        //在时间内重复调用的时候需要清空之前的定时任务
        if (timer) {
          clearTimeout(timer)
        }
        //适用于首次需要立刻执行的
        if (immediate && !timer) {
          func.apply(this,arguments)
        }
        timer = setTimeout(() => {
          func.apply(this,arguments)
        }, delay)
      }
    },
    // 产品名称搜索
    getProductNameSerach(prodName, index) {
      if (this.s_organName) {
        this.productNameList = [];
        this.list[index].showproductName = false;
        const data = {
          // i_organ_full_name: this.s_organName,
          goldCJToken: this.goldCJToken,
          i_prod_name: prodName,
          // i_asso_regist_num: this.s_manageScale,
          i_org_name: this.org_name,
        };
        if (this.setTimer) clearTimeout(this.setTimer);
        this.setTimer = setTimeout(() => {
          cjServices.productSerach(this, data).then(function (response) {
            if (response.body && response.body.error_code == "0") {
              let result = response.body.results;
              if (result.length > 0) {
                this.list[index].showproductName = true;
                this.productNameList = result;
                this.isPerson(this.productNameList);
              }
            } else {
              Toast({
                message: response.body.error_info,
                duration: 2000,
              });
            }
          });
        }, 300);
      }
    },

    // 感兴趣业务
    getInterested() {
      cjServices.interestedBusiness(this).then(function (response) {
        if (response.body && response.body.error_code == "0") {
          let result = response.body.results;
          this.interestedBusi = result;
          this.interestedBusi.map((item) => {
            item.checked = false;
          });
        } else {
          Toast({
            message: response.body.error_info,
            duration: 2000,
          });
        }
      });
    },

    // 判断是什么类型下的部门下拉
    isPerson(selectArray) {
      if (this.isSpecial) {
        this.zdepartOptions = selectArray;
        this.departOptions = this.zdepartOptions;
      } else {
        this.sdepartOptions = selectArray;
        this.departOptions = this.sdepartOptions;
      }
    },
    // 开户资金选择变化时清空资金账号
    // openChange(proIndex) {
    //   this.list[proIndex].s_moneyCount = "";
    // },
    trimObj(obj) {
      for (var i in obj) {
        obj[i] = typeof obj[i] == "string" ? obj[i].trim() : obj[i];
      }
      return obj;
    },
    submit: function () {
      this.interestedlist = "";
      this.interestedBusi.forEach((item) => {
        if (item.checked) {
          this.interestedlist = this.interestedlist + item.busi_id + ",";
        }
      });
      this.interestedlist = this.interestedlist.slice(0, -1);
      let reqData = {
        goldCJToken: this.goldCJToken,
        // i_mobile: this.isSpecial ? this.z_mobile : this.s_mobile,
        // i_verify_code: this.isSpecial ? this.z_smsCode : this.s_smsCode,
        // i_serial_no: this.isSpecial ? this.z_serialNo : this.s_serialNo,
        i_user_type: this.isSpecial ? "2" : "1", // 1-私募产品，2-专业投资者组
        i_channel: "2", // 1-PC,2-app
        i_organ_full_name: this.isSpecial ? "" : this.s_organName,
        i_asso_regist_num: this.isSpecial ? "" : this.s_manageScale,
        i_establish_date: this.isSpecial ? "" : this.s_selectDate,
        i_contact_name: this.isSpecial ? this.z_name : this.s_name,
        i_organ_scale: this.s_assoNum, //管理规模
        i_new_product: this.s_hProductChecked, //是否有新发产品的计划 1是 0否
        // i_fund_account: this.s_fundCount,
        i_contact_pos: this.isSpecial ? "" : this.s_position,
        // i_contact_mobile: this.isSpecial ? this.z_mobile : this.s_mobile,
        i_email: this.isSpecial ? this.z_email : this.s_email,
        i_recommend_organ: this.isSpecial ? "" : this.s_recOrgan,
        // i_recommend_person: !this.isSpecial && (this.s_recOrgan == '1' || this.s_recOrgan == '2')? this.s_recPerson : this.z_recPerson,
        // i_recommend_dept: !this.isSpecial && (this.s_recOrgan == '1' || this.s_recOrgan == '2')? this.s_recDept : this.z_recDept,
        i_recommend_person: this.isSpecial
          ? this.z_recPerson
          : this.s_recPerson,
        i_recommend_dept: this.isSpecial ? this.z_recDept : this.s_recDept,
        // i_if_fund_account: this.s_fundAccount == "1" ? 1:0,
        // i_if_cqt: this.s_cqtChecked,
        i_interested_busi: this.interestedlist, //感兴趣业务
        // i_if_ifind: this.s_iFundChecked,
        // i_if_mskj: this.s_gEditionChecked,
        i_prod_info: this.isSpecial
          ? ""
          : encodeURIComponent(this.contactList()) //产品信息(字符串拼接格式： 产品策略;产品名称;备案编号;规模;经理姓名;是;资金账号@@产品策略;产品名称;备案编号;规模;经理姓名;是;资金账号)
      };
      reqData = this.trimObj(reqData);
      if (!this.checkParam(reqData)) {
        return false;
      }
      cjServices.goldSubmit(this, reqData).then(function (response) {
        if (response.body && response.body.error_code == "0") {
          this.showPopup = true;
          this.isSuccess = true;
          this.tabflag = '2'
          this.getProData()
          this.getValidateImg();
          this.code_err = response.body.error_code
        } else {
          this.showPopup = true;
          this.isSuccess = false;
          this.errorMsg = "提示:" + response.body.error_info;
          this.code_err = response.body.error_code
          // 刷新图形验证码
          this.getValidateImg();
        }
      });
    },
    deleteList(index) {
      this.list.splice(index, 1);
    },
    checkParam(reqData) {
      let res = true;
      // for (let i = 0; i < this.list.length; i++) {
      //   if (this.list[i].s_proStra !== this.list[i].s_GroStra) {
      //     Toast("产品策略与产品所选组别选择一致才能报名成功");
      //     return false;
      //   }
      // }
      // 1-私募产品，2-专业投资者组
      // if (!reqData.i_mobile) {
      //   Toast("请输入手机号");
      //   return false;
      // }
      // if (!reqData.i_serial_no) {
      //   Toast("请获取短信验证码");
      //   return false;
      // }
      // if (!reqData.i_verify_code) {
      //   Toast("请输入短信验证码");
      //   return false;
      // }
      if (!reqData.i_organ_full_name) {
        Toast("请输入机构全称");
        return false;
      }
      if (!reqData.i_contact_name) {
        Toast("请输入联系人姓名");
        return false;
      }
      if (!(reqData.i_email && cjServices.checkEmail(reqData.i_email))) {
        Toast("请输入正确的电子邮箱");
        return false;
      }
      // if (reqData.i_if_fund_account == 1) {
      //   if (!reqData.i_fund_account) {
      //     Toast("请输入资金账号");
      //     return false;
      //   }
      // }
      if (reqData.i_user_type == "2") {
        // if (!reqData.i_fund_account) {
        //   Toast("请输入参赛资金账号");
        //   return false;
        // }
        // 专业里判断推荐部门 推荐人是否必填
        if (!reqData.i_recommend_dept) {
          Toast("请输入推荐部门并选择");
          return false;
        }
        if (!reqData.i_recommend_person) {
          Toast("请输入推荐人");
          return false;
        }
      } else if (reqData.i_user_type == "1") {
        if (!reqData.i_organ_full_name) {
          Toast("请输入机构全称");
          return false;
        }
        if (!reqData.i_establish_date) {
          Toast("请输入机构成立日期");
          return false;
        }
        if (!reqData.i_contact_pos) {
          Toast("请输入联系人职位");
          return false;
        }
        if (!reqData.i_recommend_organ) {
          Toast("请选择推荐机构");
          return false;
        }
        if (!reqData.i_interested_busi) {
          Toast("请选择感兴趣业务");
          return false;
        }
        if (
          reqData.i_recommend_organ == "1" ||
          reqData.i_recommend_organ == "2"
        ) {
          if (!reqData.i_recommend_dept) {
            Toast("请输入推荐部门并选择");
            return false;
          }
          if (!reqData.i_recommend_person) {
            Toast("请输入推荐人");
            return false;
          }
        }
        if (!reqData.i_prod_info) {
          Toast("请输入产品信息");
          return false;
        }
        console.log(223333, this.list)
        if (this.list.some(v => v['showProOptions'] == true)) {
          Toast("请完善产品策略信息");
          return false;
        }
        if (!this.s_amtCheck) {
          Toast("请勾选协议");
          return false;
        }
      } else {
        return false;
      }
      return res;
    },
    getValue(s_proStra) {
      // for (let i = 0; i < this.proOptions.length; i++) {
      //   if (this.proOptions[i].strategy_name == s_proStra) {
      //     return this.proOptions[i].strategy_id;
      //   }
      // }
      const numlast = s_proStra.length - 1
      return  s_proStra[numlast] || ''
      // return "";
    },
    contactList() {
      let str = "";
      for (let i = 0; i < this.list.length; i++) {
        this.list[i] = this.trimObj(this.list[i]);
        let item = this.list[i];
        console.log(44455555, item.s_proStra)
        // ||!item.s_openChecked||!item.s_moneyCount
        if (
          !item.s_proStra ||
          !item.s_proName ||
          // !item.s_GroStra ||
          !item.s_proNum ||
          !item.s_mamScale ||
          !item.s_manName
        ) {
          return "";
        }
        // if (item.s_openChecked == "1" && !item.s_moneyCount) {
        //   console.log(123);
        //   return "";
        // }
        if (this.list.length >= 2 && i < this.list.length - 1) {
          str += `${item.s_proName};${this.getValue(item.s_proStra)};${item.s_proNum};${item.s_mamScale};${item.s_manName};${(item.s_netWorth == "1" ? "是" : "否")}@@`
          // str +=
          //   item.s_proName +
          //   ";" +
          //   this.getValue(item.s_proStra) +
          //   ";" +
          //   item.s_proNum +
          //   ";" +
          //   item.s_mamScale +
          //   ";" +
          //   item.s_manName +
          //   ";" +
          //   (item.s_netWorth == "1" ? "是" : "否") +
          //   // ";" +
          //   // item.s_moneyCount +
          //   "@@";
        } else {
          str += `${item.s_proName};${this.getValue(item.s_proStra)};${item.s_proNum};${item.s_mamScale};${item.s_manName};${(item.s_netWorth == "1" ? "是" : "否")}@@`
          // str +=
          //   // 产品名称
          //   item.s_proName +
          //   ";" +
          //   // 产品组别
          //   this.getValue(item.s_proStra) +
          //   ";" +
          //   // 产品备案编号
          //   item.s_proNum +
          //   ";" +
          //   // 产品规模
          //   item.s_mamScale +
          //   ";" +
          //   // 经理姓名
          //   item.s_manName +
          //   ";" +
          //   (item.s_netWorth == "1" ? "是" : "否") +
          //   // ";"+
          //   // item.s_moneyCount+
          //   "@@";
        }
      }
      return str;
    },
    closeTips() {
      this.showPopup = false;
      if (this.isSuccess) {
        // if (navigator.userAgent.indexOf("cjsccjeh") > -1) {
        //   this.goBack();
        // } else {
        //   this.$router.push({ path: "/newIndex" });
        // }
      } else {
        if (this.code_err === '-9999') {
          this.$router.replace("/login")
        }
      }
    },
    addProInfo() {
      this.list.push({
        showproductName: false,
        showProOptions: false,
        s_proStra: [],
        s_showProOption: [],
        s_proName: "",
        s_proNum: "",
        s_mamScale: "",
        s_manName: "",
        s_moneyCount: "",
        showGroOptions: false,
        // s_GroStra: "",
        s_netWorth: 0,
      });
      // this.getOrganizationName();
    },
    // 打开日期时间选择器
    openPicker() {
      this.$refs.startPicker.open();
    },
    // 点击日期时间选择器"开始日期"中的确认按钮
    handleConfirm(value) {
      // 赋值给开始日期
      let dValue = this.dateFormat(value);
      this.s_dateValue = this.formatDateStr(dValue);
      // console.log(dValue, 111111, value);
      this.s_selectDate = this.formatDateStr(dValue);
    },
    // 点击日期时间选择器中的取消按钮
    handleCancel() {
      // 开始日期
      // this.startDate = new Date(this.formatDateStr(this.s_selectDate))
    },
    // 时间文本格式化
    dateFormat(date, format = this.$date.YMD_S) {
      // 先转换为时间戳
      date = new Date(date).getTime();
      // 再根据时间戳转换为想要的时间文本
      return this.$date.format(date, format);
    },
    formatDateStr(strDate) {
      if (strDate != null && strDate.length >= 8) {
        return strDate.slice(0, 10)
      }
      return strDate;
    },
    isCjehApp() {
      if (navigator.userAgent.indexOf("cjsccjeh") > -1) {
        return true;
      } else {
        return false;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import "sass/gold/common.scss";
@import "sass/gold/signUp.scss";
.gold-view {
  .footer {
    background-image: linear-gradient(90deg, #f6e8aa 0%, #ffaa75 100%);
    button {
      display: block;
      width: 100%;
      height: 49px;
      line-height: 49px;
      background-color: transparent;
      font-size: 17px;
      color: #69270f;
      font-weight: 600;
      border: none;
      padding: 0;
      margin: 0;
      &:focus {
        outline: 0;
      }
    }
  }
}
</style>
